/** Legend entries shown on the dashboard before the "+N more" link. Groupings
 * with 8 or fewer entries never truncate (Stage has 6); Category (16) and
 * Discipline (30) do. */
export const LEGEND_LIMIT = 8;

/** Which legend entries to render, and how many are left over. Truncation only
 * applies where a "+N more" link can be offered (the dashboard); the expanded
 * view passes `truncate: false` and lists everything. */
export function legendView<T>(
  entries: T[],
  truncate: boolean,
  limit = LEGEND_LIMIT
): { visible: T[]; hiddenCount: number } {
  if (!truncate || entries.length <= limit) return { visible: entries, hiddenCount: 0 };
  return { visible: entries.slice(0, limit), hiddenCount: entries.length - limit };
}
